/* THIS FILE IS GENERATED ON RUNTIME. DO NOT EDIT */

import { ComponentClassNameFactory } from 'lib/contexts/ComponentClassNameFactory';
import { getPropStylesFactory } from '@/utils/getPropStylesFactory';
import { getComponentStylesFactory } from '@/utils/getComponentStylesFactory';
import { getComponentThemeFactory } from '@/utils/getComponentThemeFactory';
import make_styler from '../index';

export const styles = {
  "quote_variant_primary": "after:content-[\"»\"] before:content-[\"«\"]",
  "quote_variant_secondary": "after:content-[\"»\"] before:content-[\"«\"]",
  "quote_size_default": "text-quote-sm sm:text-quote-md after:mb-0.5 after:ml-0.5 before:mb-0.5 before:mr-0.5",
  "quote_colors_default": "after:text-primary-700 before:text-primary-700",
  "quotationMark_variant_primary": "hidden",
  "quotationMark_variant_secondary": "hidden",
  "quotationMark_size_default": "mb-4",
  "quotationMark_colors_default": "",
  "author_variant_primary": "inline-block",
  "author_variant_secondary": "inline-block",
  "author_size_default": "text-headline-xs mt-3",
  "author_colors_default": "",
  "variant_primary": "text-center",
  "variant_secondary": "flex items-start text-left",
  "size_default": "w-full p-5",
  "colors_default": ""
};

const c = make_styler(styles);

export const propClassName = getPropStylesFactory(c, styles, "Quotebox");

export const componentClassName = getComponentStylesFactory(propClassName);

export const componentTheme = getComponentThemeFactory(styles);

export const {
  ClassNameContext,
  ClassNameProvider,
  useClassName,
  useTheme,
} = ComponentClassNameFactory(componentClassName, styles);
  
export default c;